export const Global = {
    equalize: function () {
        var w = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

        if (document.querySelector(".page-navigation-container") && w >= 992) {
            var tallest = 0;
            
            document.querySelectorAll('.page-navigation-block-panel, .supply-water-link-list-block, .waste-search-block').forEach(index => {
                if (tallest < index.offsetHeight) {
                    tallest = index.offsetHeight;
                }
            });

            document.querySelectorAll('.page-navigation-block-panel, .supply-water-link-list-block, .waste-search-block').forEach(index => {
                index.style.minHeight = tallest + "px";
            });
        }
    },
    alternateContent: function () {
        const alternateContentMarketing = document.querySelectorAll('.cookieconsent-optout-marketing');
        const alternateContentMarketingContent =  document.querySelector('.js-generic-data').dataset.alternateContent;
        alternateContentMarketing.forEach(item => {
            item.innerHTML = alternateContentMarketingContent;
            item.style.height = "auto";
        });
    },
    openCookiebotSettings: function () {
        const settingsLinks = document.querySelectorAll('.js-cookiebot-settings')
        if (window.Cookiebot && window.Cookiebot.renew) {
            settingsLinks.forEach(link => {
                link.addEventListener('click', (e) => {
                    e.preventDefault();
                    window.Cookiebot.renew();
                });
            });
        }
    },
    // TODO: This does not handle vue components well (like the contact-block.vue)
    setExternalLinks: function () {
        const links = document.querySelectorAll('a');        
        links.forEach((link) => {
            //Link is not in the main content area / hero content area / content-area / bottom-content-area / front page lifts area, do not manipulate
            
            if(!link.closest('.main-content-area') &&
               !link.closest('.hero-content') &&
               !link.closest('.content-area') &&
               !link.closest('.bottom-content-area') &&
               !link.closest('.lifts-content-area')) return;
            const targetUrl = new URL(link.href, document.baseURI);
            const isDifferentHostname = targetUrl.hostname !== window.location.hostname;
            if(isDifferentHostname) {
                // Target all svg:s inside the link
                const icons = link.querySelectorAll('svg');
                if(!icons.length) {
                    // Link does not contain any svg, add external link icon
                    link.insertAdjacentHTML('beforeend', '<svg class="icon icon-hsy-icon-external-link" aria-hidden="true" focusable="false"><use xlink:href="#icon-hsy-external-link"></use></svg>');
                    link.classList.add('external-link');
                }
                // There are elements that have more than one svg inside them, we need to target the correct one
                icons.forEach(icon => {
                    if(icon.classList.contains('icon-hsy-icon-arrow-right-short-bold')) {
                        // Link is an external link, remove default icon and...
                        icon.classList.remove('icon-hsy-icon-arrow-right-short-bold');
                        // ...add external link icon
                        icon.classList.add('icon-hsy-icon-external-link');
                        icon.querySelector('use').setAttribute('xlink:href', '#icon-hsy-external-link');
                    }                        
                });
            }
        });    
    },
    observeAccordionChanges: function () {
        const observer = new MutationObserver((mutationsList, observer) => {
            const accordions = document.querySelectorAll('.accordion');
            if (accordions.length > 0) {
                // Disconnect the global observer once we�ve found the accordions
                observer.disconnect();

                // Observe each accordion for content changes
                const accordionContentObserver = new MutationObserver(() => {
                    Global.setExternalLinks();
                });

                accordions.forEach(accordion => {
                    accordionContentObserver.observe(accordion, { childList: true, subtree: true });
                });

                // Also run once immediately in case content is already there
                Global.setExternalLinks();
            }
        });

        // Start watching the body for added nodes
        observer.observe(document.body, { childList: true, subtree: true });
    },
    initLinkObserver: function () {
        this.setExternalLinks(); // Initial call for external links
        this.observeAccordionChanges(); // Start observing accordion changes
    },
    backToTop: function () {
        const backToTopButton = document.getElementById('js-back-to-top');
        if(!backToTopButton) return;
        backToTopButton.addEventListener('click', (e) => {
            e.preventDefault();
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        });
    }
}
// Self invoking function bound to listen to OneTrust event, semicolon at the beginning to please ESLint
;(function() {
    window.addEventListener("DOMContentLoaded", () => {
        Global.initLinkObserver();
        Global.alternateContent();
        Global.backToTop();
        Global.openCookiebotSettings();
    });
})();